import {
    observable
} from 'mobx';

// 菜单

const initial = {
    list: [],
    open: !1,
    agreeting: "Hi there!"
}

export default class Menu {
    @observable datas = initial;


    changeText(t) {
        switch (Number(t)) {
            case 2:
                this.datas.agreeting = "关于Spotlight";
                break;
            case 3:
                this.datas.agreeting = "一些文章&示例";
                break;
            default:
                this.datas.agreeting = "Hi there!";
                break;
        }
    }
}